import { NzMessageService } from 'ng-zorro-antd/message';
import { FieldValueChangedArgs } from 'src/app/layout/field-value-changed-args';
import { LayoutService } from 'src/app/layout/layout.service';
import { RecordModel } from 'src/app/layout/record-model';
import { ModuleStructure } from '../module-structure';

export class ServiceContract {
  constructor(
    private layoutService: LayoutService,
    private messageService: NzMessageService
  ) {
    layoutService.objectLoadChanged.subscribe(
      (args: {
        recordModel: RecordModel;
        moduleStructure: ModuleStructure;
      }) => {
        if (args.moduleStructure.module.ObjectType !== 'oServiceContracts') {
          return;
        }

        this.displayLines(args.recordModel, args.moduleStructure);
      }
    );

    layoutService.fieldValueChanged.subscribe((args: FieldValueChangedArgs) => {
      if (
        args.recordProperty !== undefined &&
        args.recordProperty.Name === 'ContractType' &&
        args.sectionTagName === 'ServiceContracts'
      ) {
        this.displayLines(args.recordModel, args.moduleStructure);
      }
    });
  }

  displayLines(recordModel: RecordModel, moduleStructure: ModuleStructure) {
    const contractType = recordModel.Categories.find(
      (c) => c.Id === 'ServiceContracts'
    )?.Lines[0]?.Properties?.find(
      (p) => p.Name === 'ContractType'
    ).ValueAsObject;

    if (contractType === undefined) {
      return;
    }

    if (contractType === 'ct_Customer' || contractType === 'C') {
      this.hideTab(moduleStructure, 'items-gr');
      this.hideTab(moduleStructure, 'items-sn');
      this.hideTab(moduleStructure, 'sc-gr');

      this.showTab(moduleStructure, 'sc-sn');
    } else if (contractType === 'ct_ItemGroup' || contractType === 'G') {
      this.hideTab(moduleStructure, 'items-sn');
      this.hideTab(moduleStructure, 'sc-sn');

      this.showTab(moduleStructure, 'items-gr');
      this.showTab(moduleStructure, 'sc-gr');
    } else if (contractType === 'ct_SerialNumber' || contractType === 'S') {
      this.hideTab(moduleStructure, 'items-gr');
      this.hideTab(moduleStructure, 'sc-gr');

      this.showTab(moduleStructure, 'items-sn');
      this.showTab(moduleStructure, 'sc-sn');
    }

    this.layoutService.moduleStructureChanged.emit();
  }

  hideTab(moduleStructure: ModuleStructure, additionalIdentifier: string) {
    const sectionToHide = moduleStructure.module.Sections.find(
      (s) => s.AdditionalIdentifier === additionalIdentifier
    );
    if (sectionToHide === undefined) {
      return;
    }

    sectionToHide.AdditionalInformationParsed.Hidden = true;
  }

  showTab(moduleStructure: ModuleStructure, additionalIdentifier: string) {
    const sectionToHide = moduleStructure.module.Sections.find(
      (s) => s.AdditionalIdentifier === additionalIdentifier
    );
    if (sectionToHide === undefined) {
      return;
    }

    sectionToHide.AdditionalInformationParsed.Hidden = false;
  }
}
